{
  "name": "81-(47-Limit) < 256° (Sabat: The Tree)",
  "description": "81-tone Rational Intonation gamut, consisting of pitch classes derived from odd harmonic partials not exceeding 256° and comprising only products of primes <= 47. This set combines all of the preceding pitches, and adds primes up to 47° and their multiples. The prime limit chosen is the highest prime that allows each pitch to be part of an harmonic chord comprising (at least) identities 1° 3° 5°.",
  "scale": [
    "129/128",
    "65/64",
    "33/32",
    "133/128",
    "135/128",
    "17/16",
    "69/64",
    "35/32",
    "141/128",
    "143/128",
    "9/8",
    "145/128",
    "147/128",
    "37/32",
    "75/64",
    "19/16",
    "153/128",
    "77/64",
    "155/128",
    "39/32",
    "5/4",
    "161/128",
    "81/64",
    "41/32",
    "165/128",
    "21/16",
    "169/128",
    "85/64",
    "171/128",
    "43/32",
    "87/64",
    "175/128",
    "11/8",
    "45/32",
    "91/64",
    "23/16",
    "185/128",
    "93/64",
    "187/128",
    "47/32",
    "189/128",
    "95/64",
    "3/2",
    "195/128",
    "49/32",
    "99/64",
    "25/16",
    "203/128",
    "51/32",
    "205/128",
    "207/128",
    "13/8",
    "209/128",
    "105/64",
    "215/128",
    "27/16",
    "217/128",
    "55/32",
    "221/128",
    "111/64",
    "7/4",
    "225/128",
    "57/32",
    "115/64",
    "231/128",
    "29/16",
    "117/64",
    "235/128",
    "119/64",
    "15/8",
    "121/64",
    "243/128",
    "245/128",
    "123/64",
    "247/128",
    "31/16",
    "125/64",
    "63/32",
    "253/128",
    "255/128",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "OddPartials(47L)",
  "built_in_group": "Odd Partial Pitch Class Sets",
  "key_labels": "note_names",
  "note_names": [
    "1",
    "129",
    "65",
    "33",
    "133",
    "135",
    "17",
    "69",
    "35",
    "141",
    "143",
    "9",
    "145",
    "147",
    "37",
    "75",
    "19",
    "153",
    "77",
    "155",
    "39",
    "5",
    "161",
    "81",
    "41",
    "165",
    "21",
    "169",
    "85",
    "171",
    "43",
    "87",
    "175",
    "11",
    "45",
    "91",
    "23",
    "185",
    "93",
    "187",
    "47",
    "189",
    "95",
    "3",
    "195",
    "49",
    "99",
    "25",
    "203",
    "51",
    "205",
    "207",
    "13",
    "209",
    "105",
    "215",
    "27",
    "217",
    "55",
    "221",
    "111",
    "7",
    "225",
    "57",
    "115",
    "231",
    "29",
    "117",
    "235",
    "119",
    "15",
    "121",
    "243",
    "245",
    "123",
    "247",
    "31",
    "125",
    "63",
    "253",
    "255"
  ],
  "note_colors": [
    "#ff8989",
    "#c9a573",
    "#e9d7d3",
    "#dfffd6",
    "#f4e6f2",
    "#fffae5",
    "#cfcfcf",
    "#95c69b",
    "#ffcba8",
    "#ffb8da",
    "#90f9cd",
    "#ffffff",
    "#b4cbfe",
    "#f8c9c9",
    "#cee3e2",
    "#fef5be",
    "#d6f7ff",
    "#cfcfcf",
    "#e9ecc1",
    "#0afff3",
    "#e6d7fe",
    "#fffae5",
    "#91b195",
    "#ffffff",
    "#f89b87",
    "#ddfe95",
    "#ffe5e5",
    "#dbb3ff",
    "#eceae4",
    "#d6f7ff",
    "#c9a573",
    "#8aafff",
    "#ffd270",
    "#dfffd6",
    "#fffae5",
    "#ebd0e0",
    "#95c69b",
    "#dfebdb",
    "#68f3ec",
    "#ccdbce",
    "#ffb8da",
    "#ffe5e5",
    "#e5fff9",
    "#ffffff",
    "#e9d7d3",
    "#f8c9c9",
    "#dfffd6",
    "#fef5be",
    "#b0a9fe",
    "#cfcfcf",
    "#e0b49e",
    "#95c69b",
    "#e6d7fe",
    "#caf7e3",
    "#ffcba8",
    "#e8c28c",
    "#ffffff",
    "#0fd2c8",
    "#ddfe95",
    "#c3b4d5",
    "#cee3e2",
    "#ffe5e5",
    "#fef5be",
    "#d6f7ff",
    "#90d597",
    "#e9ecc1",
    "#8aafff",
    "#e6d7fe",
    "#f79cc5",
    "#ded4d5",
    "#fffae5",
    "#c3ffad",
    "#ffffff",
    "#ffb59a",
    "#f89b87",
    "#dbe6ff",
    "#68f3ec",
    "#ffef8a",
    "#ffe5e5",
    "#69ec79",
    "#eceae4"
  ],
  "equivSteps": 81,
  "fundamental": 440,
  "reference_degree": 56,
  "center_degree": 0,
  "rSteps": 9,
  "drSteps": 5,
  "hexSize": 38,
  "rotation": -16.102113751,
  "lumatone_anchor_note": 41,
  "lumatone_anchor_channel": 2
}
